import { render, staticRenderFns } from "./UserFeedback.vue?vue&type=template&id=fb003638&"
import script from "./UserFeedback.vue?vue&type=script&lang=js&"
export * from "./UserFeedback.vue?vue&type=script&lang=js&"
import style0 from "./UserFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports